import * as actionTypes from "../actionTypes/actionTypes";

const initialState = {
  drawings: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  deleteDrawing: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  updateView: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  selectedPage: 0,
};

export const drawingReducer = (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.GET_DRAWINGS:
      return {
        ...newState,
        drawings: { ...newState.drawings, isLoading: true, hasError: false },
      };

    case actionTypes.SELECTED_DRAWING_PAGE:
      return {
        ...newState,
        selectedPage: action.payload,
      };

    case actionTypes.GET_DRAWINGS_SUCCESS:
      return {
        ...newState,
        drawings: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_DRAWINGS_FAILURE:
      return {
        ...newState,
        drawings: { data: action.payload, isLoading: false, hasError: true },
      };

    case actionTypes.DELETE_DRAWING:
      return {
        ...newState,
        deleteDrawing: {
          ...newState.deleteDrawing,
          isLoading: true,
          hasError: false,
        },
      };
    case actionTypes.DELETE_DRAWING_SUCCESS:
      return {
        ...newState,
        deleteDrawing: {
          data: action.payload,
          isLoading: false,
          hasError: false,
        },
      };
    case actionTypes.DELETE_DRAWING_FAILURE:
      return {
        ...newState,
        deleteDrawing: {
          data: action.payload,
          isLoading: false,
          hasError: true,
        },
      };
    case actionTypes.UPDATE_DRAWING:
      return {
        ...newState,
        updateDrawing: {
          ...newState.deleteDrawing,
          isLoading: true,
          hasError: false,
        },
      };
    case actionTypes.UPDATE_DRAWING_SUCCESS:
      return {
        ...newState,
        updateDrawing: {
          data: action.payload,
          isLoading: false,
          hasError: false,
        },
      };
    case actionTypes.UPDATE_DRAWING_FAILURE:
      return {
        ...newState,
        updateDrawing: {
          data: action.payload,
          isLoading: false,
          hasError: true,
        },
      };

    default:
      return { ...newState };
  }
};
